var _ellipse, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEraseTextSymbol(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 32,
    viewBox: "0 0 33 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 16.5,
    cy: 16,
    rx: 16.5,
    ry: 16,
    fill: "#008187"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.5352 23.9119C23.3797 24.0652 23.13 24.0655 22.9742 23.9127L16.419 17.4829L9.86281 23.9136C9.70733 24.0661 9.45843 24.0662 9.30284 23.9138L8.34868 22.9794C8.18843 22.8225 8.18853 22.5645 8.34891 22.4076L14.9034 15.9987L8.34891 9.58972C8.18853 9.4329 8.18843 9.17488 8.34868 9.01794L9.30284 8.08351C9.45843 7.93113 9.70733 7.93123 9.86281 8.08373L16.419 14.5145L22.9752 8.09382C23.1307 7.94153 23.3794 7.94153 23.5349 8.09382L24.4788 9.01816C24.6389 9.17502 24.6389 9.43286 24.4788 9.58972L17.9345 15.9987L24.4798 22.4086C24.6396 22.5651 24.64 22.8222 24.4808 22.9792L23.5352 23.9119Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEraseTextSymbol);
export default __webpack_public_path__ + "static/media/erase-text-symbol.3ac100ede31a262923030511b2d39091.svg";
export { ForwardRef as ReactComponent };